export const version = '2.46.0'
